module.exports = __webpack_public_path__ + "fonts/lato-bolditalic-webfont.db9221be.woff2";